<template>
  <div>

    <b-modal ref="myModalRef" hide-footer centered>

      <div centered slot="modal-title">
        {{$t('edit.activeSIP')}}
      </div>

      <div class="d-block text-center">

        <div v-if="activeSIPError" class="alert alert-danger">{{$t('anErrorOccurred')}}</div>

        {{$t('edit.areYouSureActive')}}
        <b>{{ sipName }}</b>
      </div>

      <b-button-group size="lg" class="mt25">
        <b-button size="lg" class="custom-bgr-danger" variant="danger" @click="hideModalActiveSIP()">{{$t('edit.cancel')}}</b-button>
        <b-button size="lg" class="custom-bgr-primary" variant="primary" @click="activeSip()">{{$t('edit.active')}}</b-button>
    </b-button-group>

    </b-modal>


     <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <div class="clearfix"></div>
      <div class="form-header box-list-sip mt0">{{$t('edit.sipChooseHeader')}}</div>
      <p class="sipListNote" v-html="$t('edit.sipListSelect')"></p>
      <div class="alert alert-success" v-if="sip_create == 'ok'">{{$t('alert.create.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sip_create == 'fail'">{{$t('alert.create.sip.error')}}</div>
      <div class="alert alert-success" v-if="sip_update == 'ok'">{{$t('alert.update.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sip_update == 'fail'">{{$t('alert.update.sip.error')}}</div>
      <div class="alert alert-success" v-if="sip_delete == 'ok'">{{$t('alert.delete.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sip_delete == 'fail'">{{$t('alert.delete.sip.error')}}</div>

      <ul class="list-sip">
        <li :class="{'active': item.status == 1 || item.status === 1}" v-for="(item, index) in sipList" :key="index">
          <a class="url" @click="showModalActiveSIP(item)">
            {{item.sip_username}}@{{item.sip_domain}}
          </a>
          <i @click="showModalActiveSIP(item)" class="fileIco" v-if="item.status == 0 || item.status === 0"></i>
          <font-awesome-icon @click="showModalActiveSIP(item)" :icon="fileCheck" v-if="item.status == 1 || item.status === 1"></font-awesome-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
  import file from '@fortawesome/fontawesome-free-regular/faFile';
  import check from '@fortawesome/fontawesome-free-solid/faCheck';
  import i18n from '../languages/i18n';

  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue'
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  import bButton from 'bootstrap-vue/es/components/button/button';
  import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  Vue.component('b-modal', bModal);
  Vue.directive('b-modal', bModalDirective);
  Vue.component('b-button', bButton);
  Vue.component('b-button-group', bButtonGroup);

  export default {
    components: {
      BaseHeader,
      BaseButton,
      FontAwesomeIcon,
    },
    name: 'Account',
    props: {
      update_profile: [Boolean, Number, String],
      sip_create: [Boolean, Number, String],
      sip_update: [Boolean, Number, String],
      sip_delete: [Boolean, Number, String],
    },
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        cloud_id: '',
        passwordRepeat: '',
        newPassword: '',
        oldPassword: '',
        errorMessage: [],
        user: {},
        message: '',
        sipList: [],
        sipName: '',
        sipItem: {},
        activeSIPError: false
      };
    },
    computed: {
      fileIco() {
        return file;
      },
      fileCheck() {
        return check;
      }
    },
    methods: {
      activeSip() {
        
        const token = localStorage.getItem('token');

        if ((this.sipItem.status) <= 0) {
            this.activeSIPError = false;
            this.sipList.map((i) => {
              if (i.id === this.sipItem.id) {
                i.status = 1;
              } else {
                i.status = 0;
              }
            });
            
            this.hideModalActiveSIP();
            this.axios.post('/active/' + this.sipItem.id + '?token=' + token + '&account=true').then((response) => {

                if (response.data.status) {
                  top.window.location.href = response.data.data.url;

                  setTimeout(() => {
                    this.$router.push({name: 'EditPage'});
                  }, 100);

                  this.activeSIPError = false;
                } else {
                  this.activeSIPError = true;
                }
                
                /*
                this.axios.get('/sipList?token=' + token).then(response => {
                  if (response.data.status) {
                    this.phone = response.data.data.user.phone;
                    this.email = response.data.data.user.email;
                    this.name = response.data.data.user.name;
                    this.sipList = response.data.data.sip;
                  } else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('url');
                    this.$router.push({name: 'LoginPage'});
                  }
                });
                */

            });
        } else {
            this.hideModalActiveSIP();
            if(localStorage.getItem('url')) {
              top.window.location.href = localStorage.getItem('url');
            } else {
              if(this.phone && this.cloud_id && token) {
                top.window.location.href = "csc:"+this.phone+":"+token+"@"+this.cloud_id;
              }
            }
            setTimeout(() => {
              this.$router.push({name: 'EditPage'});
            }, 100);
        }
      },
      showModalActiveSIP (item) {
        this.sipItem = item;
        this.sipName = item.sip_username + '@' + item.sip_domain;
        this.$refs.myModalRef.show()
      },
      hideModalActiveSIP () {
        this.$refs.myModalRef.hide()
      }
    },
    beforeMount () {
      const token = localStorage.getItem('token');
      if ( (!token) || (token == "") || (token == null) || (token == undefined) || (typeof token == 'undefined') ) {
        localStorage.removeItem('token');
        this.$router.push({name: 'LoginPage'});
      }
      this.axios.get('/sipList?token=' + token).then(response => {
        if (response.data.status && response.data.data.sip.length > 0 && response.data.data.user) {
          this.phone = response.data.data.user.phone;
          this.email = response.data.data.user.email;
          this.name = response.data.data.user.name;
          this.sipList = response.data.data.sip;
          this.cloud_id = response.data.data.cloud_id;
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('url');
          this.$router.push({name: 'LoginPage'});
        }
      })
    }
  };
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/Account.vue